import { getImageryDate, getCopyright } from './utils';

import classes from './StatusBar.module.css';
import { captureException } from '@sentry/react';
import { CustomAttribution } from '@/views/map/CustomAttribution/CustomAttribution';
import { useSmallScreen } from '@/hooks/useWindowDimension';
import { useMobileInspectMode } from '@/hooks/useMobileInspectMode';
import { Box, Flex } from '@mantine/core';

interface Props {
  /** ISO date of image capture */
  imageDate: string;
  /** Product used to capture image
      'PNE', # Pléiades Neo, to be deprecated once status bar is dynamic for all customers
      'PNEO', # Pléiades Neo
      'PHR', # Pléiades
      'SPOT', # SPOT
    */
  imageProvider: string;
  showImageryDate: boolean;
}

export const StatusBar = ({
  imageDate,
  imageProvider,
  showImageryDate,
}: Props) => {
  let date;
  const isSmallScreen = useSmallScreen();
  const isMobileInspectMode = useMobileInspectMode();

  try {
    if (!imageDate && !imageProvider) {
      return null;
    }

    date = new Date(imageDate);
  } catch (e) {
    captureException(e);
    return null;
  }

  return (
    <Flex
      data-testid="status-bar"
      className={classes.status}
      justify="space-between"
      align="center"
    >
      <Box>
        {getImageryDate(showImageryDate, date)}
        {getCopyright(date, imageProvider)}
      </Box>
      {!isMobileInspectMode && isSmallScreen && (
        <CustomAttribution compact useFullVersion />
      )}
      {!isSmallScreen && (
        <CustomAttribution
          title={'Disclaimer'}
          compact={false}
          useFullVersion={false}
        />
      )}
    </Flex>
  );
};
